<template>
  <v-card :loading="false">
    <v-overlay :absolute="true" :value="isComponentLoading">
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-row class="pa-3">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="searchText"
          :hint="lang($store, 'sap/listings.global.filter.hints.search_name')"
          persistent-hint
          single-line
          :loading="false"
        >
        </v-text-field>
      </v-col>
      <v-col v-if="rolesItems" cols="12" md="3">
        <v-select
          v-model="searchParams.role"
          :hint="lang($store, 'sap/listings.global.filter.hints.role')"
          :items="rolesItems"
          persistent-hint
          single-line
          :loading="false"
        ></v-select>
      </v-col>
      <v-col v-if="regionsItems" cols="12" md="3">
        <v-select
          v-model="searchParams.region"
          :hint="lang($store, 'sap/listings.global.filter.hints.region')"
          :items="regionsItems"
          persistent-hint
          single-line
          :loading="false"
        ></v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
/* constants */
import {
  CLEANERS, MANAGER_TOP, MANAGERS, ADMIN, CONTACT,
} from '@/constants/roles';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import regionsFilter from '@/mixins/filters/regionsFilter';
import i18n from '@/i18n';
/* components */

export default {
  name: 'FilterUsers',
  mixins: [isComponentLoading, regionsFilter],
  components: {},
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search: '',
        role: null,
        region: null,
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      searchText: '',
      searchTextTimeout: null,
      searchParams: {},
    };
  },
  mounted() {
    this.searchParams = {
      search: this.defaultSearchParams.search,
      role: this.defaultSearchParams.role,
      region: this.defaultSearchParams.region,
    };
  },
  computed: {
    rolesItems() {
      return [
        {
          text: i18n.t('enums.roles.all'),
          value: null,
        },
        {
          text: i18n.t('enums.roles.contact'),
          value: CONTACT,
        },
        {
          text: i18n.t('enums.roles.cleaner_base'),
          value: CLEANERS.CLEANER_BASE,
        },
        {
          text: i18n.t('enums.roles.cleaner_complex'),
          value: CLEANERS.CLEANER_COMPLEX,
        },
        {
          text: i18n.t('enums.roles.foreman'),
          value: CLEANERS.FOREMAN,
        },
        {
          text: i18n.t('enums.roles.manager_top'),
          value: MANAGERS.MANAGER_TOP,
        },
        {
          text: i18n.t('enums.roles.manager_base'),
          value: MANAGERS.MANAGER_BASE,
        },
        {
          text: i18n.t('enums.roles.manager_complex'),
          value: MANAGERS.MANAGER_COMPLEX,
        },
      ];
    },
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
    searchText(newVal) {
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(() => {
        this.searchParams.search = newVal;
      }, 500);
    },
  },
};
</script>

<style scoped></style>
